import { render, staticRenderFns } from "./gasdata-analyze.vue?vue&type=template&id=51481348&scoped=true&"
import script from "./gasdata-analyze.vue?vue&type=script&lang=ts&"
export * from "./gasdata-analyze.vue?vue&type=script&lang=ts&"
import style0 from "./gasdata-analyze.vue?vue&type=style&index=0&id=51481348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51481348",
  null
  
)

export default component.exports